import axiosInstance from "@/axios/axiosInstance";
import { message } from "antd";
export const setupAuthInterceptor = (navigate) => {
  // 响应拦截器
  axiosInstance.interceptors.response.use(
    (response) => {
      // 如果响应中包含token失效或被其他设备登录的标识
      if (
        response.data.code === 401 ||
        response.data.code === "TOKEN_INVALID" ||
        response.data.code === "TOKEN_EXPIRED"
      ) {
        // 清除本地存储的登录信息
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");

        // 显示提示消息
        message.warning("您的账号已在其他设备登录，请重新登录");

        // 跳转到登录页
        navigate("/login");
      }
      return response;
    },
    (error) => {
      if (
        error.response &&
        (error.response.status === 401 || error.response.data.code === 401)
      ) {
        // 清除本地存储的登录信息
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");

        // 显示提示消息
        // message.warning("您的账号已在其他设备登录，请重新登录");

        // 跳转到登录页
        navigate("/login");
      }
      return Promise.reject(error);
    }
  );
};
